import { REQUEST_TIMEOUT_MS } from "../../lib/constants/requestTimeout.constants";

/**
 * Combines the caller's signal with the request timeout. `AbortSignal.any`
 * only exists from Safari / iOS 17.4, so older WebViews (e.g. the in-app
 * games) fall back to forwarding both signals into a single controller.
 */
export const withRequestTimeout = (
  signal?: AbortSignal | null,
): AbortSignal => {
  const timeoutSignal = AbortSignal.timeout(REQUEST_TIMEOUT_MS);

  if (!signal) return timeoutSignal;

  if (typeof AbortSignal.any === "function")
    return AbortSignal.any([signal, timeoutSignal]);

  const controller = new AbortController();

  if (signal.aborted) {
    controller.abort(signal.reason);
    return controller.signal;
  }

  const onAbort = (event: Event) => {
    signal.removeEventListener("abort", onAbort);
    timeoutSignal.removeEventListener("abort", onAbort);
    controller.abort((event.target as AbortSignal).reason);
  };

  signal.addEventListener("abort", onAbort);
  timeoutSignal.addEventListener("abort", onAbort);

  return controller.signal;
};
